module.exports = __webpack_public_path__ + "static/media/12.ccef467d.jpg";